var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('api-provider',{attrs:{"request":_vm.endpoint},on:{"success":_vm.handleSuccess,"error":_vm.handleError}},[_c('div')])}
var staticRenderFns = []

export { render, staticRenderFns }